import { FC, useEffect } from 'react';
import styled from '@emotion/styled';
import { useAtomValue, useSetAtom } from 'jotai';
import appConfig from 'app-config';
import AzarHistory from 'src/components/AzarOnly/History';
import BottomTabBar, { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import FooterBase from 'src/components/Footer';
import { FOOTER_VERTICAL_PADDING } from 'src/components/Footer/style';
import Header from 'src/components/Header';
import { HEADER_HEIGHT, TABLET_HEADER_HEIGHT } from 'src/components/Header/styles';
import withPrivateRoute from 'src/components/HOC/withPrivateRoute';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
import VividiHistory from 'src/components/VividiOnly/History';
import useQuickSlotPage from 'src/hooks/useQuickSlotPage';
import { historyNotificationAtom, markHistoryNotificationAsReadAtom } from 'src/stores/history/atom';
const RootStyle = styled.div`
  width: var(--100vw);
  background-color: ${({
  theme
}) => theme.color.surface1};
`;
const HistoryWrap = styled.div`
  min-height: calc(var(--100vh, 100dvh) - ${TABLET_HEADER_HEIGHT} - ${BOTTOM_TAB_BAR_HEIGHT});

  display: flex;
  flex-direction: column;

  ${({
  theme
}) => theme.screenSize.desktop} {
    min-height: calc(var(--100vh, 100dvh) - ${HEADER_HEIGHT});
  }
`;
const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 64px;
  ${({
  theme
}) => theme.screenSize.tablet} {
    padding-top: 54px;
  }
`;
const Footer = styled(FooterBase)`
  ${({
  theme
}) => theme.screenSize.tablet} {
    padding-bottom: calc(${FOOTER_VERTICAL_PADDING} + ${BOTTOM_TAB_BAR_HEIGHT});
  }
`;
const HistoryContents = (() => {
  switch (appConfig.serviceCode) {
    case 'vividi':
      return VividiHistory;
    case 'azar':
    default:
      return AzarHistory;
  }
})();
const HistoryView: FC = () => {
  useQuickSlotPage('FRIEND_ADD_REQUEST');
  const historyNotification = useAtomValue(historyNotificationAtom);
  const markHistoryNotificationAsRead = useSetAtom(markHistoryNotificationAsReadAtom);
  useEffect(() => {
    if (historyNotification) {
      markHistoryNotificationAsRead();
    }
  }, [historyNotification, markHistoryNotificationAsRead]);
  return <RootStyle data-sentry-element="RootStyle" data-sentry-component="HistoryView" data-sentry-source-file="History.tsx">
      <Header data-sentry-element="Header" data-sentry-source-file="History.tsx" />
      <ContentWrap data-sentry-element="ContentWrap" data-sentry-source-file="History.tsx">
        <HistoryWrap data-sentry-element="HistoryWrap" data-sentry-source-file="History.tsx">
          <HistoryContents data-sentry-element="HistoryContents" data-sentry-source-file="History.tsx" />
        </HistoryWrap>
        <Footer data-sentry-element="Footer" data-sentry-source-file="History.tsx" />
      </ContentWrap>
      <BottomTabBar data-sentry-element="BottomTabBar" data-sentry-source-file="History.tsx" />
    </RootStyle>;
};
export default withWebClientValidation(withPrivateRoute(HistoryView));